
/* Color search tokens, examples:
 * [[[voiture#1]]] -> <span style="color: #0D8050">voiture</span>
 * [[[voiture blindée#1]]] -> <span style="color: #0D8050">voiture blindée</span>
 * [[[peu à peu#3]]] -> <span style="color: #0D8050">peu à peu</span>
 *
 * Inspiration for the regex: https://stackoverflow.com/a/26900132
*/
export const colorQueryTokens = (text) => {
  const regex1 = /\[\[\[([^#]+)#(\w+)\]\]\]/gi;
  const regex2 = /\{\{\{([^}]*)\}\}\}/gi;
  return text.replace(regex1, '<span style="color: #0D8050" title="$2">$1</span>').replace(regex2, '<span style="font-weight: bold;">$1</span>');
}

export const createParagraph = (text) => {
  if (text) {
    return text.replace(/(.+)/, '<span>$1</span>');
  }
  return '<p/>'
}

export const prepString = (text) => {
  let newText = createParagraph(text);
  newText = colorQueryTokens(newText);
  return newText;
}

export const prepDangerouslySetInnerHTMLString = (text) => {
  return {__html: prepString(text)};
}

export const formatMeta = (metadata,template) => {
  for (var field of Object.keys(metadata)) {
    const re=RegExp("\\{"+field+"\\}");
    const replaceStr=metadata[field]? metadata[field] :"";
    template=template.replace(re,replaceStr);
  }
  template=template.replace(/\{.*?\}/,"");
  return template;
}

export const specialSlice = (text,leftOrRight,nbChars) => {
  if (text.length<=nbChars) {
    return text;
  }

  var tokens=text.split(" ");
  var result;
  var n;
  var re=/\[\[|(#\d+)?\]\]|[{}][{}]/g; // matching [[ and #id]] and {{ }}

  // coupe à gauche
  if (leftOrRight === "l") {
    n=1;
    while (n < tokens.length && tokens.slice(-n).join(" ").replace(re,'').length < nbChars) {
      n++;
    }
    result=tokens.slice(-n).join(" ");

  } else {
     // coupe à droite
    n=1;
    while (n < tokens.length-1 && tokens.slice(0,n).join(" ").replace(re,'').length < nbChars) {
      n++;
    }
    result=tokens.slice(0,n).join(" ");
  }

  return result;
}
